/** Display labels for Sabil / Mutawatteen outstanding preview rows. */
export function formatSabilOutstandingTypeLabel(sabilType: string | null | undefined): string {
  const normalized = String(sabilType ?? "")
    .trim()
    .toUpperCase();
  switch (normalized) {
    case "CHULA":
      return "Chula";
    case "ESTABLISHMENT":
      return "Establishment";
    case "MUTTAVATTEEN":
      return "Mutawatteen (monthly)";
    case "MUTTAVATTEEN_YEARLY":
      return "Mutawatteen (yearly)";
    default:
      return normalized || "—";
  }
}

/**
 * Label for the current-rate preview column. Chula bills monthly; Establishment bills yearly
 * (`isYearlySabilType` on the API) — the same `currentTakhmeenId` rate field means a different
 * cadence per type, so the column header must not always say "Monthly".
 */
export function formatSabilOutstandingRateColumnLabel(
  sabilType: string | null | undefined
): "Monthly" | "Yearly" {
  return String(sabilType ?? "")
    .trim()
    .toUpperCase() === "ESTABLISHMENT"
    ? "Yearly"
    : "Monthly";
}
